module.exports = __webpack_public_path__ + "static/media/video.9692e255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Dalyellup/video.jpg
// module id = 230
// module chunks = 0